import { TWebsiteBuilderFileType } from "../../shared/components/fileDropZone/WebsiteBuilderFileDropZone";

export const WEBSITE_BUILDER_IMAGE_ALLOWED_FILE_TYPES: TWebsiteBuilderFileType[] = ["svg", "png", "jpg"];
export const WEBSITE_BUILDER_VIDEO_ALLOWED_FILE_TYPES: TWebsiteBuilderFileType[] = ["mp4", "mov", "webm"];

export function isWebsiteBuilderImageAllowedFileSubtype(subtype: string) {
  return subtype === "svg+xml" || subtype === "png" || subtype === "jpeg";
}

export function isWebsiteBuilderVideoAllowedFileSubtype(subtype: string) {
  return subtype === "mp4" || subtype === "quicktime" || subtype === "webm";
}
